// Career-outcome framing (v8.08). We keep the underlying bucket
// signal (likely / target / ambitious / long_shot) but re-label the
// user-facing pill so it answers "what does this mean for my career?"
// rather than "how hard is it to get in?". The old "Reach / Target /
// Safety" language conflates selectivity with fit; the new copy
// aligns with WUA's positioning that outcomes matter more than
// prestige.
//
// Chip labels are single-token so the pill stays compact next to a
// long uni + course name. The longer two-part framing lives in
// `ChanceLegend.jsx` as the `aka` line for anyone who wants
// context.
const BUCKET_LABELS = {
  likely: "Well-matched",
  target: "Realistic",
  ambitious: "Aspirational",
  highly_ambitious: "Long shot",
  long_shot: "Long shot",
};

export default function ChanceBadge({ bucket, label, size = "md" }) {
  const cls = {
    likely: "chance-likely",
    target: "chance-target",
    ambitious: "chance-ambitious",
    highly_ambitious: "chance-highly_ambitious",
    long_shot: "chance-highly_ambitious",
  }[bucket] || "chance-target";
  const display = BUCKET_LABELS[bucket] || label || "Balanced";
  const sz = size === "sm" ? "text-xs px-2 py-0.5" : "text-sm px-3 py-1";
  return (
    <span
      data-testid={`chance-badge-${bucket}`}
      className={`${cls} ${sz} rounded-full inline-flex items-center gap-1.5 font-mono font-semibold uppercase tracking-wider`}
    >
      <span className="inline-block h-1.5 w-1.5 rounded-full bg-current opacity-60" />
      {display}
    </span>
  );
}
